module.exports = __webpack_public_path__ + "static/media/iphone_screen4.622767d7.png";